
import { Router, NavigationStart } from '@angular/router';
import { EventEmitter, Injectable } from '@angular/core';
import { MessageModel, ContentPageModel } from '../../model/models';
import { Subject, Observable } from 'rxjs';
import { SectionTextModel } from '../../model/sectionTextModel';
import { SectionContentModel } from '../../model/sectionContentModel';

@Injectable()
export class CurrentPageWatcherService {


private title:EventEmitter<string>=new EventEmitter<string>();
private userInformationEmitter:EventEmitter<UserData>=new EventEmitter<UserData>();
private menuTitleEmitter : EventEmitter<string> = new EventEmitter<string>();
private brokerStepsMenuDisplayEmitter : EventEmitter<boolean> = new EventEmitter<boolean>();
private connectedUserEmitter : EventEmitter<boolean> = new EventEmitter<boolean>();
private userMessages = new Subject<any>();
private stepMessage = new Subject<ContentPageModel>();
private headerContent = new Subject<SectionContentModel>();
private keepAfterRouteChange = false;
lastStep : boolean = false;
displayUserMessage : boolean = false;

constructor(private router:Router) { 
  
              this.clearUserMessage();
         
}
 public pageChanged():EventEmitter<string>{
    return this.title;
 }

 public notifyMenuTitleChanged():EventEmitter<string>{
   return this.menuTitleEmitter;
}
 public notifyConnectedUserInfo():EventEmitter<UserData>{
   return this.userInformationEmitter;
}

public notifyLeftMenuDisplay():EventEmitter<boolean>{
   return this.brokerStepsMenuDisplayEmitter;
}

sendUserMessages(userMessages : Array<MessageModel> , keepAfterRouteChange=false) {
   this.keepAfterRouteChange = keepAfterRouteChange;
   this.userMessages.next(userMessages);
}

clearUserMessage() {
   this.userMessages.next(null);
}

getUserMessages(): Observable<any> {
   return this.userMessages.asObservable();
}

sendStepMessage(stepMessage : ContentPageModel) {
   this.stepMessage.next(stepMessage);
}

clearStepMessage() {
   this.stepMessage.next(null);
}

getStepMessage(): Observable<ContentPageModel> {
   return this.stepMessage.asObservable();
}
sendHeaderContent(header : SectionContentModel) {
   this.headerContent.next(header);
}

clearHeaderContent() {
   this.headerContent.next(null);
}

getHeaderContent(): Observable<any> {
   return this.headerContent.asObservable();
}

notifyConnectedUser(){
   return this.connectedUserEmitter;
}

}
export class UserData{

   constructor(public name?: string , public licenseNumber? : string){}
}


// WEBPACK FOOTER //
// ./src/app/shared/utils/CurrentPageWatcher.ts